<template>
  <div class="text-xs-center">
    <CSIcon icon="warning" color="error" :size="80" />
    <h1 class="display-4 primary--text">
      404
    </h1>
    <p class="title">
      Page not found!
    </p>

    <CSDivider />

    <CSButton
      id="button_notfound_home"
      :onClick="home"
      customClass="mt-4"
      text="Back to home page"
      color="slate100"
    />
  </div>
</template>

<script>
import CSButton from '@/components/atoms/button/CSButton.vue'
import CSDivider from '@/components/atoms/divider/CSDivider.vue'
import CSIcon from '@/components/atoms/icons/CSIcon.vue'

export default {
  name: 'CSNotFound',
  components: {
    CSDivider,
    CSButton,
    CSIcon,
  },
  methods: {
    home() {
      this.$router.push('/')
    },
  },
  mounted() {
    this.$gtm.trackView('404 - Not found')
  },
}
</script>
